export default __webpack_public_path__ + "static/media/road.67f99b7c.svg";